import { render, staticRenderFns } from "./EditLoad.vue?vue&type=template&id=3a6dcdb8&scoped=true"
import script from "./EditLoad.vue?vue&type=script&lang=js"
export * from "./EditLoad.vue?vue&type=script&lang=js"
import style0 from "./EditLoad.vue?vue&type=style&index=0&id=3a6dcdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6dcdb8",
  null
  
)

export default component.exports